import siteConfig from '@config';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: siteConfig.firebaseApiKey,
  authDomain: siteConfig.firebaseAuthDomain,
  projectId: siteConfig.firebaseProjectId,
  storageBucket: siteConfig.firebaseStorageBucket,
  messagingSenderId: siteConfig.firebaseMessagingSenderId,
  appId: siteConfig.firebaseAppId,
  measurementId: siteConfig.firebaseMeasurementId,
  privateKey: siteConfig.firebasePrivateKey,
};

const app = initializeApp(firebaseConfig);

export default app;
